export default "__VITE_ASSET__WkCENYaR__"